<div id="sidebarWrap">
    <div id="title">
        <img src="../../assets/icons/title.png">
    </div>
    <div class="sidebarItem isActive"> 
        <span class="icon">
            <img src="../../assets/icons/home.svg" alt="Girl in a jacket" width="18" height="18">
        </span>
        <span>
            Dashboard
        </span>
    </div>
    <div class="sidebarItem">
        <span class="icon">
            <img src="../../assets/icons/carbon_user-profile.svg" alt="Girl in a jacket" width="18" height="18">
        </span>
        <span>
            Student reports
        </span>
    </div>
    <div class="sidebarItem">
        <span class="icon">
            <img src="../../assets/icons/mdi_timetable.svg" alt="Girl in a jacket" width="18" height="18">
        </span>
        <span>
            Timetable
        </span>
    </div>
    <div class="bgImg">
        <img src="../../assets/icons/girlLightbulb.png">
    </div>
</div>
